// src/pages/painel/PainelResumo.js
import React from "react";
import "./painelResumo.css";
import { getNivelTier } from "../../utils/nivelTiers";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faFireFlameCurved, faUser } from "@fortawesome/free-solid-svg-icons";

const PainelResumo = ({
  nome,
  labelObjetivo,
  labelNivelAtividade,
  dataCadastro,
  xpTotal,
  nivel,
}) => {

  const formatarDataBR = (iso) => {
    if (!iso) return "";
    const [ano, mes, dia] = iso.split("-");
    return `${dia}/${mes}/${ano}`;
  };

  const tier = typeof nivel === "number" ? getNivelTier(nivel) : null;

  const xpInicioNivel = tier ? 50 * nivel * (nivel - 1) : 0;
  const xpProximoNivel = tier ? 50 * (nivel + 1) * nivel : 0;
  const xpNecessarioNivel = tier ? xpProximoNivel - xpInicioNivel : 0;
  const xpProgressoNivel = tier ? Math.max(0, (xpTotal ?? 0) - xpInicioNivel) : 0;
  const percentual = tier
    ? Math.min(100, Math.round((xpProgressoNivel / xpNecessarioNivel) * 100))
    : 0;

  return (
    <div className="painel-resumo-card">

      <div className="painel-resumo-user">
        <div className="painel-avatar">
          {nome ? nome.charAt(0).toUpperCase() : "U"}
        </div>

        <div className="painel-resumo-identificacao">
          <h2 className="painel-resumo-nome">
            Olá, {nome || "Usuário"}
            <a href="/perfil" className="painel-btn-perfil-inline">
              <FontAwesomeIcon icon={faUser} />
              Editar perfil
            </a>
          </h2>

          {dataCadastro && (
            <span className="painel-resumo-membro">
              Membro desde {formatarDataBR(dataCadastro)}
            </span>
          )}

          <div className="painel-resumo-tags">
            {labelObjetivo && (
              <span className="tag-objetivo">
                <FontAwesomeIcon icon={faFireFlameCurved} />
                {labelObjetivo}
              </span>
            )}
            {labelNivelAtividade && (
              <span className="tag-atividade">{labelNivelAtividade}</span>
            )}
          </div>
        </div>
      </div>

      {/* =============================== */}
      {/* CARD DE NÍVEL — agora é o ÚLTIMO elemento */}
      {/* =============================== */}
      {tier && (
        <div
          className={"painel-nivel-card" + (tier.brilhoIntenso ? " painel-nivel-card-brilho" : "")}
          style={{ "--tier-cor": tier.corPrincipal, "--tier-brilho": tier.corBrilho }}
          onClick={() => (window.location.href = "/nivel")}
          role="button"
        >
          <div className="painel-nivel-emblema">{tier.icone}</div>
          <div className="painel-nivel-info">
            <div className="painel-nivel-titulo">
              Nível {nivel} <span className="painel-nivel-tier-nome">· {tier.nome}</span>
            </div>
            <div className="painel-nivel-barra-fundo">
              <div
                className="painel-nivel-barra-preenchida"
                style={{ width: `${percentual}%` }}
              />
            </div>
            <div className="painel-nivel-texto-progresso">
              {xpProgressoNivel} / {xpNecessarioNivel} XP
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default PainelResumo;